import React from 'react';

export function Navbar() {
  return (
    <header className="bg-white shadow-md py-8">
      <div className="container mx-auto px-6 text-center">
        <img
          src="LOGO.png"
          alt="Farrell CPA Logo"
          className="mx-auto h-24 w-auto"
        />
        <p className="mt-4 text-gray-600 font-medium">
          Accounting, Tax & Business Consulting Services Made Simple and Stress-Free
        </p>
      </div>
    </header>
  );
}
